import { scrollToElement } from "venuescanner-js/vanilla/components/animateScroll";
// const scrollToElement = () => {}
export const isDesktop = () =>
  typeof document !== "undefined" &&
  document.querySelector("body.desktop") !== null;

export function scrollToPage(page) {
  if (typeof document === "undefined") return;
  const pageEl = document.querySelector(`div[data-page="${page}"]`);
  if (!pageEl) return;

  const container = document.querySelector(".ux-spaces-tile-scroll");
  // const scrollTop = pageEl.getBoundingClientRect().top

  // if (isDesktop()) {
  // animateScroll(document.querySelector(`.srp-container .ux-spaces-tile-scroll, .srp-container .ux-no-results-page`), { to: scrollTop + container.scrollTop - 210 })
  // window.$('.srp-container .ux-spaces-tile-scroll, .srp-container .ux-no-results-page').animate({
  //   scrollTop: scrollTop + container.scrollTop - 210
  // }, 500)
  // } else {
  scrollToElement(pageEl, { parent: container });
  // pageEl.scrollIntoView({ behavior: 'smooth' })
  // }
}

export async function scrollToSpace(container, spaceID, pulsate = false) {
  if (!container) return;
  if (typeof window === "undefined") return;
  if (typeof document === "undefined") return;
  const spaceTile = document.querySelector(`.space-tile[data-id="${spaceID}"]`);
  if (spaceTile) {
    // console.log(spaceTile, document.querySelector(`.srp-container .ux-spaces-tile-scroll, .srp-container .ux-no-results-page`))
    scrollToElement(spaceTile, {
      parent: document.querySelector(
        `.srp-container .ux-spaces-tile-scroll, .srp-container .ux-no-results-page`
      ),
    });
    // const rect = spaceTile.getBoundingClientRect()
    // const containerRect = container.getBoundingClientRect()
    // const offsetTop = (rect.top - containerRect.top) + container.scrollTop
    // const offsetLeft = (rect.left - rect.left) + container.scrollLeft

    // const topMarginPx = 20
    // const leftMarginPx = 10

    // await new Promise(resolve => {
    //   window.$('.srp-container .ux-spaces-tile-scroll, .srp-container .ux-no-results-page').animate({
    //     scrollTop: offsetTop - topMarginPx,
    //     scrollLeft: offsetLeft - leftMarginPx
    //   }, 300, resolve)
    // })
    if (pulsate) {
      spaceTile.classList.add("select-pulsate-once");
      setTimeout(() => {
        spaceTile.classList.remove("select-pulsate-once");
      }, 1000);
    }
  }
}

// const remToPx = rem => rem * parseFloat(getComputedStyle(document.documentElement).fontSize)
